import http from "../../api";

export default {
  namespaced: true,
  actions: {
    //   //Charts
    getGeneralReport({}, body) {
      return http.post("/chart/GeneralReport", body);
    },
    getAgentTransactionsAndTuaProfitDynamics({}, body) {
      return http.post("/chart/AgentTransactionsAndTuaProfitDynamics", body);
    },
    getSalesAndProfitByProviders({}, body) {
      return http.post("/chart/SalesAndProfitByProviders", body);
    },
    getSalesAndProfitDynamicsByProviders({}, body) {
      return http.post("/chart/SalesAndProfitDynamicsByProviders", body);
    },
    getSalesAndAgentsDepositesDynamic({}, body) {
      return http.post("/chart/SalesAndAgentsDepositesDynamic", body);
    },
    getAgentsDepositsAndProfitBalance({}, body) {
      return http.post("/chart/AgentsDepositsAndProfitBalance", body);
    },
    getSalesByAirtimeCredit({}, body) {
      return http.post("/chart/SalesByAirtimeCredit", body);
    },
    getNumberOfTUAAccounts({}, body) {
      return http.post("/chart/NumberOfTUAAccounts", body);
    },
    getMonthlyTotalSales({}, body) {
      return http.post("/chart/MonthlyTotalSales", body);
    },
    getMonthlyAverageReport({}, body) {
      return http.post("/chart/MonthlyAverageReport", body);
    },
    getAgentsSales({}, body) {
      return http.post("/chart/AgentsSales", body);
    },
    getUsersAndReferals({}, body) {
      return http.post("/chart/UsersAndReferals", body);
    },
    getTransactionsByUsersAndReferals({}, body) {
      return http.post("/chart/TransactionsByUsersAndReferals", body);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/chart.js